import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { FerryReturnIcon } from '@dfds-frontend/navigator-icons/icons'

import { ProductListSections } from '../../../api/travel-search-config'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import SelectField from '../shared/SelectField'
import { Offers } from './Offers'

interface OfferSelectorProps {
  onProductClicked: (minibookId: string, offerTitle: string) => void
  optionalOfferTitle?: string
  products: ProductListSections[]
  selectedMultiOffer: { minibookId: string; offerTitle: string } | undefined
}

export const OfferSelector: FC<OfferSelectorProps> = ({ onProductClicked, optionalOfferTitle, products, selectedMultiOffer }) => {
  const { activeField, closeIfActive, toggleField } = useActiveSelectField()
  const { t } = useTranslation()

  const dataAttrList = [{ name: 'selected-offer', value: `1` }]

  return (
    <div className="col-span-12 box-border h-[58px] w-full md:col-span-6 lg:col-auto">
      <SelectField
        dataAttrList={dataAttrList}
        fieldName="passenger"
        icon={<FerryReturnIcon size="md" />}
        isLoading={false}
        isOpen={activeField === ActiveSelectField.MULTI_OFFER}
        onClick={(clickedOutside) => {
          toggleField(ActiveSelectField.MULTI_OFFER, clickedOutside)
        }}
        onClose={() => closeIfActive(ActiveSelectField.MULTI_OFFER)}
        title={t('ROUTE')}
        value={selectedMultiOffer?.offerTitle ?? optionalOfferTitle ?? t('SELECT-OFFER')}
        visibleRows={2}
      >
        <div className="lg:max-h-[calc(100dvh-160px)] lg:overflow-auto">
          <Offers
            onClose={() => closeIfActive(ActiveSelectField.MULTI_OFFER)}
            onProductClicked={onProductClicked}
            products={products}
            selectedMultiOffer={selectedMultiOffer}
          />
        </div>
      </SelectField>
    </div>
  )
}
